// import hooks
import React, { useContext, useEffect, useState } from "react";

// import context
import { DatosInicioContext } from "../../context/DatosInicioContext";
import { DarkModeContext } from "../../context/DarkModeContext";

// import hoja de estilos css
import "./Cupones.css";
import "./AliadoResponsive.css";

// import componentes
import BienvenidoPanel from "../../components/comunes/BienvenidoPanel";
import DatosTickets from "../../components/comunes/DatosTickets";
import TablaTickets from "../../components/comunes/TablaTickets";
import ScrollToTopButton from "../../components/comunes/ScrollToTopButton";
import Footer from "../../components/comunes/Footer";

// import librerias
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ThreeDots } from "react-loader-spinner";

// import assets
import logo from "../../assets/img/logo.png";
import logoClaro from "../../assets/img/logo-modo-oscuro.png";
import { getToken } from "../../utils/auth";


const Tickets = () => {
  // extraigo del contexto datos y datos cupones context
  const { datosCuponesContext, codigoRespuesta, datos } =
    useContext(DatosInicioContext);

  // De datos cupones context extraigo la lista mes
    const { listaMes } = datosCuponesContext;
  // hooks para efectuar la navegacion
  const navegacion = useNavigate();

  // funcion para recargar la pagina
  function recargarPagina() {
    window.location.reload();
  }

  // url de la api
  const apiUrlToken = process.env.REACT_APP_API_TOKEN;

  // context para la modalidad del claro/oscuro
  const { darkMode } = useContext(DarkModeContext);

  // estado para controlar el spinner de carga
  const [cargando, setCargando] = useState(false);

  // consulta a la api para verificar el token
  useEffect(() => {
    const verificarToken = async () => {
      const token = getToken();
      setCargando(true);
      try {
        const response = await fetch(apiUrlToken, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ Token: token }),
        });

        if (response.ok) {
          const data = await response.json();
          if (data !== 0) {
            manejarAccesoDenegado();
          }
        } else {
          if (response.status === 401) {
            manejarRespuestaNoAutorizada();
          }
        }
      } catch (error) {}
      setCargando(false);
    };

    // funcion para redireccionar al home
    const redireccionar = () => {
      navegacion("/");
      recargarPagina();
    };

    // funcion para manejar la respuesta autorizada
    // muestra un mensaje por pantalla
    const manejarRespuestaNoAutorizada = () => {
      sessionStorage.removeItem("token"); 

      Swal.fire({
        title: "Sesión expirada o token inválido.",
        text: "Inicie sesión nuevamente.",
        imageUrl: logo,
        imageWidth: 100,
        imageHeight: 30,
        imageAlt: "Logo",
        confirmButtonText: "Ok",
        timer: 5000,
        allowOutsideClick: true,
        customClass: {
          container: darkMode
            ? "swal2-container--dark"
            : "swal2-container--light",
          confirmButton: "my-swal-button",
        },
      }).then(redireccionar);
    };

    // funcion para manejar el acceso denegado
    // muestra por pantalla un mensaje
    const manejarAccesoDenegado = () => {
      Swal.fire({
        title: "Acceso denegado.",
        text: "No tiene permisos para acceder.",
        imageUrl: logo,
        imageWidth: 100,
        imageHeight: 30,
        imageAlt: "Logo",
        confirmButtonText: "Ok",
        timer: 5000,
        allowOutsideClick: true,
        customClass: {
          container: darkMode
            ? "swal2-container--dark"
            : "swal2-container--light",
          confirmButton: "my-swal-button",
        },
      }).then(redireccionar);
    };

    verificarToken();
  }, [listaMes]);

  // condicional para mostrar el spinner de carga
  if (cargando) {
    // Muestra el spinner mientras los datos se están cargando
    return (
      <div
        className="spinner-container"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          // Fondo blanco durante la carga (en modo claro).
          background: darkMode ? undefined : "#ffffff",
        }}
      >
        <div className="">
          <div>
            <img
              className="img-fluid logo-width-spinner"
              src={darkMode ? logoClaro : logo}
              alt="logo SOCO"
            />
          </div>
          <div className="ms-3">
            <ThreeDots
              visible={true}
              height="60"
              width="60"
              color="#b4c400 "
              radius="9"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        </div>
      </div>
    );
  }

  // fecha y hora actual que se muestra en el header de la seccion
  const hoy = new Date();

  return (
    <div
      className={darkMode ? "aliado-cupones aliado-cupones-dark" : "aliado-cupones"}
      translate="no"
    >
      <main className="aliado-cupones-shell">
        <header className="aliado-cupones-header">
          <div>
            <span className="aliado-cupones-kicker">CRM Aliado</span>
            <h1>Cupones</h1>
          </div>
          <div className="aliado-cupones-date">
            {hoy.toLocaleDateString("es-AR")} |{" "}
            {hoy.toLocaleTimeString("es-AR", { hour: "2-digit", minute: "2-digit" })}
          </div>
        </header>
        <div className="aliado-cupones-filter">
          <BienvenidoPanel />
        </div>
        <ScrollToTopButton />
        <div className="aliado-cupones-kpis">
          <DatosTickets datosCuponesContext={datosCuponesContext} />
        </div>
        <div className="aliado-cupones-table-card">
          <TablaTickets listaMes={listaMes} datos={datos} />
        </div>
        <div className="aliado-cupones-footer">
          <Footer />
        </div>
      </main>
    </div>
  );
};

export default Tickets;
